module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "allotmentWrapper"
    }
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_c('h4', {
    staticClass: "pending-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.gridLotes'))
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegridLot),
      expression: "showTreegridLot"
    }],
    staticClass: "row"
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "concManualLotes",
      "result": _vm.resultLot,
      "treeGridLayoutPath": "auditoria",
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "concManualLotes",
      "cfgObj": _vm.treeGridCfgLot,
      "showExportButton": false,
      "showHrTopGrid": false
    }
  })], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0e4ca9a2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e4ca9a2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/manualConciliation/allotment.pug
// module id = 1366
// module chunks = 0